<i18n src="@/lang/actions.json"></i18n>
<i18n src="@/lang/messages.json"></i18n>
<i18n>
{
    "en": {
        "texts": {
            "language": "Language"
        },
        "field_name": "Field name",
        "add_field_title": "Add new field to data",
        "short_description": "Short description",
        "advanced_title": "Advanced settings title",
        "name": "Name",
        "description": "Description",
        "fields": {
            "type": "Type",
            "code": "Code"
        }
    },
    "ua": {
        "texts": {
            "language": "Мова"
        },
        "field_name": "Field name",
        "add_field_title": "Add new field to data",
        "short_description": "Короткий опис",
        "advanced_title": "Назва у розширенних налаштуваннях",
        "name": "Назва",
        "description": "Опис",
        "fields": {
            "type": "Тип",
            "code": "Код"
        }
    },
    "ru": {
        "texts": {
            "language": "Language"
        },
        "field_name": "Field name",
        "add_field_title": "Add new field to data",
        "short_description": "Short description",
        "advanced_title": "Advanced settings title",
        "name": "Name",
        "description": "Description",
        "fields": {
            "type": "Тип",
            "code": "Код"
        }
    }
}
</i18n>

<template>
  <el-main>
    <component
      :is="require('../_snippets/header_actions/header_actions').default"
    >
      <template slot="button-group">
        <template v-for="(a, k) in model.actions">
          <el-button
            :key="k"
            v-if="edit_mode === a.in_edit_mode"
            v-show="a.show || !(a.show === false)"
            v-bind="a.props"
            @click="handleAction(a.handler)"
            >{{ $t("actions." + k) }}</el-button
          >
        </template>
      </template>
    </component>
    <el-container>
      <el-main>
        <el-form :inline="true" label-position="left" class="text_form">
          <template v-for="(v, k) in model.schema">
            <el-form-item v-if="v.editable" :key="k" :label="$t('fields.' + k)">
              <el-input v-model="model[k]" v-if="edit_mode"></el-input>
              <div v-text="model[k]" v-else></div>
            </el-form-item>
          </template>
        </el-form>
        <el-form
          v-if="model.allowEditData"
          label-position="top"
          class="text_form"
        >
          <component
            :is="require('../_snippets/header_actions/header_actions').default"
          >
            <template slot="left-side">
              {{ $t("texts.language") }}
              <el-select size="small" v-model="data_locale">
                <el-option
                  size="small"
                  v-for="(l, k) in $store.state.i18n.messages"
                  :key="k"
                  :value="k"
                  :label="l.title"
                />
              </el-select>
            </template>
            <template slot="button-group">
              <el-button
                size="small"
                v-if="edit_mode"
                @click="show_add_field_dialog = true"
                >{{ $t("actions.new_text_field") }}
              </el-button>
              <div v-else></div>
            </template>
          </component>

          <el-form-item
            v-for="(v, k) in model.data"
            :key="k"
            :label="edit_mode ? '' : $t(k)"
            :class="{ 'el-edited': edit_mode }"
            label-width="200px"
          >
            <vue-simplemde
              v-model="model.data[k][data_locale]"
              v-if="edit_mode"
              :title="k"
              :key="data_locale"
            />
            <div
              class="text_value"
              v-html="marked(v[data_locale] || '')"
              v-else
            ></div>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>

    <el-dialog
      :title="$t('add_field_title')"
      :visible.sync="show_add_field_dialog"
    >
      <el-form>
        <el-form-item :label="$t('field_name')">
          <el-input v-model="new_field_name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show_add_field_dialog = false">{{
          $t("actions.cancel")
        }}</el-button>
        <el-button
          type="primary"
          :disabled="
            (model.data && typeof model.data[new_field_name] !== 'undefined') ||
              !new_field_name
          "
          @click="handleAddNewField"
          >{{ $t("actions.save") }}</el-button
        >
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import DirectoryTexts from "../../store/classes/DirectoryTexts";
import { mapGetters } from "vuex";
import VueSimplemde, { marked } from "../_snippets/md_editor/vue-simplemde";

export default {
  name: "texts_details",
  components: { VueSimplemde },
  data() {
    return {
      marked: marked,
      model: {},
      edit_mode: false,
      show_add_field_dialog: false,
      new_field_name: "",
      data_locale: this.locale,
      old_data: ""
    };
  },
  created() {
    this.data_locale = this.locale;
    new DirectoryTexts().getModelByUUID(this.$route.params.id).then(model => {
      this.model = model;
      if (!this.model.uuid) {
        this.edit_mode = true;
      }
    });
  },
  methods: {
    handleAction(handler) {
      let h = handler();
      if (!(h instanceof Promise)) {
        return;
      }
      h.then(param => {
        switch (param) {
          case "edit":
            this.old_data = JSON.stringify(this.model.data);
            this.edit_mode = true;
            break;
          case "save":
            if (
              this.model.type === "service" &&
              this.old_data.localeCompare(JSON.stringify(this.model.data)) !== 0
            ) {
              this.$confirm(
                this.$t("messages.service_texts_changed.message", {
                  service: this.model.code
                }),
                {
                  confirmButtonText: this.$t(
                    "messages.service_texts_changed.btn_confirm"
                  ),
                  cancelButtonText: this.$t(
                    "messages.service_texts_changed.btn_cancel"
                  )
                }
              )
                .then(() => {
                  this.updateWidgetLocales();
                })
                .catch(() => {});
            }
            this.edit_mode = false;
            break;
          case "cancel":
            this.old_data = "";
            if (this.model.uuid) {
              this.edit_mode = false;
              break;
            }
          // eslint-disable-next-line no-fallthrough
          case "delete":
          case "go_back":
            this.$router.replace({ name: "texts" });
        }
      });
    },
    handleAddNewField() {
      this.model.addNewDataField(this.new_field_name);
      this.show_add_field_dialog = false;
    },
    updateWidgetLocales() {
      this.$api
        .mutate({
          mutation: require("../../graphql/widgets/widgets_mutation.graphql"),
          variables: {
            code: this.model.code,
            make_locales: true
          }
        })
        .then(() => {
          this.$notify.success({
            title: "Success",
            message: `Translations for "${this.model.code}" updated`
          });
        })
        .catch(() => {
          this.$notify.error({
            title: "Error",
            message: "Something went wrong!"
          });
        });
    }
  },
  computed: {
    ...mapGetters(["locale"])
  }
};
</script>

<style scoped>
.text_value {
  background-color: #fff;
  padding: 0.3rem 1rem;
}

.el-button-group > .el-button {
  float: none;
}
</style>
<style>
.text_value > p {
  margin: 0;
}

.text_form > .el-form-item > .el-form-item__label {
  width: 100% !important;
}

.text_form.el-form--inline {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  background-color: #fff;
}
</style>
